

let currentAbort = null;

export function setProductSyncAbort(abortFn) {
  currentAbort = abortFn;
}

export function abortProductSync() {
  const fn = currentAbort;
  if (fn) fn();
}
